import { memo, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { Button, Col } from "../App.styles";
import {
    DesignationItemFooter,
    DesignationItemThumb,
    DesignationItemViewRow,
    BodyRow,
    ActionWrapper,
} from "./DesignationItemView.style";
import ImageThumbnail from "../common/ImageThumbnail";

const DesignationItemView = ({
    canReorder,
    id,
    onEdit,
    onReorder,
    task_type,
    position,
    count,
    ...designation
}) => {
    const { t } = useTranslation();
    const [error, setError] = useState(false);
    const handleOnEdit = useCallback(() => onEdit(), [onEdit])

    if (!designation) {
        return null;
    }

    const { description, name, assets } = designation;

    const photo = assets?.photos.find((photo) => photo.name === "media" && photo.url);

    const ActionEdit = () => (
        <Button className="btn--flat d-block w-100" onClick={handleOnEdit}>
            <FontAwesomeIcon icon={faEdit} /> {t('Edit')}
        </Button>
    )

    return (
        <>
            <div className="p-4">
                <DesignationItemViewRow>
                    <Col sm="2" className="designation-item__thumb flex-column">
                        <DesignationItemThumb hasImage={photo?.url} error={error}>
                            {photo?.url && (
                                <ImageThumbnail
                                    alt={name}
                                    src={photo.url}
                                    onError={() => setError(true)}
                                />
                            )}
                        </DesignationItemThumb>
                    </Col>
                    <Col sm="10" className="col--stretch d-block d-sm-flex">
                        <div className="flex flex-col flex-grow-1">
                            <BodyRow className="flex-grow-1">
                                <Col md="8" xl="10" className="align-items-unset">
                                    <div className="flex-grow-1 d-flex flex-column justify-content-between">
                                        <div>
                                            <strong>{name}</strong>
                                            <div dangerouslySetInnerHTML={{ __html: description }} />
                                        </div>
                                    </div>
                                </Col>
                            </BodyRow>
                        </div>
                    </Col>
                </DesignationItemViewRow>
                <DesignationItemFooter>
                    <Col className="justify-content-end col--stretch">
                        <ActionWrapper>
                            <ActionEdit />
                        </ActionWrapper>
                    </Col>
                </DesignationItemFooter>
            </div>
        </>
    );
};

export default memo(DesignationItemView);
